<template>
  <!-- TODO: nav -->
  <div class="container col-md-7 col-lg-7 col-xl-5">
    <router-view />
  </div>
</template>
